export enum actionTypes {
  GET_PERMISOS_AVISO = 'GET_PERMISOS_AVISO',
  GET_PERMISOS_AVISO_SUCCESS = 'GET_PERMISOS_AVISO_SUCCESS',
  GET_PERMISOS_AVISO_ERROR = 'GET_PERMISOS_AVISO_ERROR',
  GET_PERMISOS_AVISO_RESET = 'GET_PERMISOS_AVISO_RESET',
}

export enum PermisosAvisoStatus {
  Idle,
  Loading,
  Error,
  Success,
}

export interface PermisoAviso {
  usuarioId: number
  usuario: string
  tipoUsuario: string
  puedeVer: boolean
  puedeEditar: boolean
}

export interface PermisosAvisoState {
  permisosAviso: PermisoAviso[] | null
  permisosAvisoStatus: PermisosAvisoStatus
}

export const initialState: PermisosAvisoState = {
  permisosAviso: null,
  permisosAvisoStatus: PermisosAvisoStatus.Idle,
}

export interface GetPermisosAviso {
  type: typeof actionTypes.GET_PERMISOS_AVISO
  payload: null
}

export interface GetPermisosAvisoSuccess {
  type: typeof actionTypes.GET_PERMISOS_AVISO_SUCCESS
  payload: PermisoAviso[]
}

export interface GetPermisosAvisoError {
  type: typeof actionTypes.GET_PERMISOS_AVISO_ERROR
  payload: boolean
}

export interface GetPermisosAvisoReset {
  type: typeof actionTypes.GET_PERMISOS_AVISO_RESET
  payload: null
}

export type PermisosAvisoActions =
  | GetPermisosAviso
  | GetPermisosAvisoSuccess
  | GetPermisosAvisoError
  | GetPermisosAvisoReset
